import { Component } from '@angular/core';
import { MigrationsCucmHuntListsContext } from './services/cisco/migrations-cucm-hunt-lists.context';
import { MigrationsCucmHuntListsPollingContext } from './services/cisco/migrations-cucm-hunt-lists-polling.context';
import { MigrationsCucmDirectoryNumbersPollingContext } from './services/cisco/migrations-cucm-directory-numbers-polling.context';
import { MigrationsCucmDirectoryNumberContext } from './services/cisco/migrations-cucm-directory-number.context';
import { MigrationsCucAutoAttendantsContext } from './services/cisco/migrations-cuc-auto-attendants.context';
import { MigrationsCucAutoAttendantsPollingContext } from './services/cisco/migrations-cuc-auto-attendants-polling.context';
import { MigrationsAssessmentsContext } from './services/migrations-assessments.context';
import { MigrationsAssessmentsPollingService } from './services/migrations-assessments-polling.service';
@Component({
  selector: 'ziro-migrations',
  templateUrl: 'migrations.component.html',
  styleUrls: ['migrations.component.scss'],
  providers: [
    MigrationsAssessmentsContext,
    MigrationsAssessmentsPollingService,
    MigrationsCucmHuntListsContext,
    MigrationsCucmHuntListsPollingContext,
    MigrationsCucmDirectoryNumbersPollingContext,
    MigrationsCucmDirectoryNumberContext,
    MigrationsCucAutoAttendantsContext,
    MigrationsCucAutoAttendantsPollingContext,
  ],
  standalone: false,
})
export class MigrationsComponent {}
